import { CommonModule, LowerCasePipe } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { VolService } from '../../core/vol.service';
import { environment } from '../../../environments/environment';
import { globals } from '../../../environments/globals';

@Component({
    selector: 'vol-card',
    templateUrl: './vol-card.html',
    standalone: true,
    imports: [CommonModule, LowerCasePipe]
})
export class VolCardComponent implements OnInit {
  appURL: string = environment.appURL;
  mediaURL: string = environment.mediaURL;
  @Input() id: string = '';
  @Input() uid: string = '';
  @Input() highlights: boolean = true;
  @Input() image: boolean = true;

  vol: any;
  directory: any = globals.directory;
  directory_data: any;

  constructor(
    private vs: VolService,
  ) {}

  ngOnInit() {
    if (this.id) {
      this.vs.volDetail(this.id).subscribe(vol => {
        this.vol = vol;
        if(this.vol.country) {
          this.directory_data = this.directory[this.vol.country];
        }
      })
    }
  }
}
